import { useQuery } from "react-query";
import { getMeterPointAgreements } from "../services";

export const useMeterPointAgreements = (
  accountNumber: string | undefined,
  meterPointId: string | undefined,
) => {
  return useQuery(
    [
      "accounts/meterpoints/agreements",
      {
        accountNumber: accountNumber!,
        meterPointId: meterPointId!,
      },
    ],
    getMeterPointAgreements,
    { enabled: !!accountNumber && !!meterPointId },
  );
};
